module.exports = __webpack_public_path__ + "img/google.a94b08ff.svg";